import { Routes, Route } from "react-router-dom";

import AdminLayout from "../layout/AdminLayout";
import Login from "../pages/admin/Login";
import AdminHome from "../pages/admin/AdminHome";
import UsersPage from "../pages/admin/usuarios/UsersPage";
import RolesPage from "../pages/admin/roles/RolesPage";
import PermisosPage from "../pages/admin/permisos/PermisosPage";
import CategoryFormModal from "../pages/admin/Categorias/CategoriesPage";
import ShippingFormModal from "../pages/admin/metodos_envio/ShippingMethodsPage";
import BrandsPage from "../pages/admin/marcas/BrandsPage";
import CustomersPage from "../pages/admin/Customers/CustomersPage";
import ProtectedRoute from "./ProtectedRoute";
import CustomerAddressesPage from "../pages/admin/Customers/CustomerAddressesPage";
import ProductsPage from "../pages/admin/productos/ProductsPage";
import ProductFormPage from "../pages/admin/productos/ProductFormPage";
import OrdersPage from "../pages/admin/pedidos/OrdersPage";
import RequirePerm from "./RequirePerm";

function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>

          <Route index element={<AdminHome />} />
          <Route element={<RequirePerm perm="View user" />}>
          <Route path="config/users" element={<UsersPage />} />
          </Route>
          <Route element={<RequirePerm perm="View rol" />}>
          <Route path="config/roles" element={<RolesPage />} />
          </Route>
          <Route element={<RequirePerm perm="View permissions" />}>
          <Route path="config/Permissions" element={<PermisosPage />} />
          </Route>
          <Route element={<RequirePerm perm="View categories" />}>
          <Route path="Categories" element={<CategoryFormModal />} />
          </Route>
          <Route element={<RequirePerm perm="View shipping methods" />}>
          <Route path="shipping-methods" element={<ShippingFormModal />} />
          </Route>
          <Route element={<RequirePerm perm="View brand" />}>
          <Route path="brands" element={<BrandsPage />} />
          </Route>
          <Route element={<RequirePerm perm="View customer" />}>
           <Route path="customers" element={<CustomersPage />} />
           </Route>
           <Route element={<RequirePerm perm="Update direccion customer" />}>
           <Route path="customers/:clienteId/addresses" element={<CustomerAddressesPage />} />
           </Route>
           <Route element={<RequirePerm perm="View product" />}>
           <Route path="products" element={<ProductsPage />} />
           </Route>
           <Route element={<RequirePerm perm="Create product" />}>
           <Route path="products/new" element={<ProductFormPage />} />
           </Route>
           <Route element={<RequirePerm perm="Update product" />}>
           <Route path="products/:id/edit" element={<ProductFormPage />} />
           </Route>
           <Route element={<RequirePerm perm="View orders" />}>
          <Route path="orders" element={<OrdersPage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default AdminRoutes;
